import type { StatusValue } from 'types/spherePoints';

// Mirrors the relative ordering of backend `STATUS_PRIORITY` in graph-service.
// Lower value = better status. Used only for delta direction: "did this get better or worse?"
// Order (best→worst): on_track, needs_attention, at_risk, critical, blocked
export const STATUS_PRIORITY: Record<StatusValue, number> = {
  on_track: 0,
  needs_attention: 1,
  at_risk: 2,
  critical: 3,
  blocked: 4,
  unknown: -1,
};

export type DeltaDirection = 'improved' | 'declined' | 'same';

export function deriveDelta(
  current: StatusValue,
  previous: StatusValue | null
): DeltaDirection | null {
  if (!previous || previous === 'unknown' || current === 'unknown') return null;
  if (previous === current) return 'same';
  return STATUS_PRIORITY[current] < STATUS_PRIORITY[previous] ? 'improved' : 'declined';
}
